var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-subscribe-form" },
    [
      _c("div", { staticClass: "form__heading" }, [
        _c("h2", { staticClass: "form__title" }, [
          _vm._v(_vm._s(_vm.businessTitle))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form__block" }, [
        _vm.website == "athome"
          ? _c("ul", { staticClass: "form__list" }, [
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      name: "business_registration",
                      options: _vm.businessRadioOptions,
                      value: _vm.business_form_state,
                      label: _vm.businessLabel
                    },
                    on: { input: _vm.triggerBusinessForm }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.business_form_state === "1"
        ? _c("div", { attrs: { id: "business-form" } }, [
            _vm.website == "staffhousing"
              ? _c("input", {
                  attrs: {
                    type: "hidden",
                    name: "business_registration",
                    value: "1"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "form__list" },
              [
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: {
                        label: _vm.companyName,
                        name: _vm.companyNameInput
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.website == "staffhousing"
                  ? [
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "alpha_spaces_dash",
                                expression: "`alpha_spaces_dash`"
                              }
                            ],
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsFirstName,
                              name: _vm.subscriptionsFirstNameInput
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsMiddleName,
                              name: _vm.subscriptionsMiddleNameInput
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "alpha_spaces_dash",
                                expression: "`alpha_spaces_dash`"
                              }
                            ],
                            attrs: {
                              label:
                                (_vm.locales &&
                                  _vm.locales.subscriptions &&
                                  _vm.locales.subscriptions.contact_person +
                                    " ") + _vm.subscriptionsLastName,
                              name: _vm.subscriptionsLastNameInput
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyLegalForm,
                            name: _vm.companyLegalFormInput
                          }
                        })
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyChamberOfCommerceNumber,
                            name: _vm.companyChamberOfCommerceNumberInput
                          }
                        })
                      : _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyChamberOfCommerceNumber,
                            name: _vm.companyChamberOfCommerceNumberInput
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyVatNumber,
                            name: _vm.companyVatNumberInput
                          }
                        })
                      : _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "alpha_num_spaces",
                              expression: "`alpha_num_spaces`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyVatNumber,
                            name: _vm.companyVatNumberInput
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|phone_number",
                              expression: "`required|phone_number`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyPhoneNumber + " (*)",
                            name: _vm.companyPhoneNumberInput
                          }
                        })
                      : _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyPhoneNumber,
                            name: _vm.companyPhoneNumberInput
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _vm.website == "staffhousing"
                      ? _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|email",
                              expression: "`required|email`"
                            }
                          ],
                          attrs: {
                            label: _vm.companyEmail + " (*)",
                            name: _vm.companyEmailInput
                          }
                        })
                      : _c("v-textfield-public", {
                          attrs: {
                            label: _vm.companyEmail,
                            name: _vm.companyEmailInput
                          }
                        })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-textfield-public", {
                      attrs: {
                        label: _vm.companyInvoiceEmail,
                        name: _vm.companyInvoiceEmailInput
                      }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.business_form_state === "0"
        ? _c("div", { attrs: { id: "personal-form" } }, [
            _c("div", { staticClass: "form__heading" }, [
              _c("h2", { staticClass: "form__title" }, [
                _vm._v(_vm._s(_vm.subscriptionsFamilyType))
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "form__list" }, [
              _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-radios-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      label: _vm.subscriptionsIAm,
                      name: _vm.subscriptionsFamilyTypeInput,
                      options: _vm.subscriptionsFamilyTypeOptions
                    },
                    on: { input: _vm.triggerFamilyType }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.family_type_state == "several_friends"
                ? _c(
                    "li",
                    { staticClass: "form__item" },
                    [
                      _c("v-textfield-public", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric|min_value:0|max_value:5",
                            expression:
                              "`required|numeric|min_value:0|max_value:5`"
                          }
                        ],
                        attrs: {
                          label: _vm.subscriptionNumberOfAdults,
                          name: "number_of_adults"
                        },
                        model: {
                          value: _vm.number_of_adults_value,
                          callback: function($$v) {
                            _vm.number_of_adults_value = _vm._n($$v)
                          },
                          expression: "number_of_adults_value"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__heading" }, [
              _c("h2", { staticClass: "form__title" }, [
                _vm._v(_vm._s(_vm.subscriptionsIncome))
              ])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "form__list" },
              [
                _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-checkboxes-public", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|make_choice",
                          expression: "`required|make_choice`"
                        }
                      ],
                      attrs: {
                        label: _vm.subscriptionsIAm,
                        name: _vm.subscriptionsTypeOfIncomeInput,
                        options: _vm.subscriptionsTypeOfIncomeOptions
                      },
                      on: { input: _vm.triggerIncomeAdditionalForms }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.income_form_work_business
                  ? [
                      _vm.income_form_work
                        ? _c(
                            "li",
                            { staticClass: "form__item" },
                            [
                              _c("v-radios-public", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|make_choice",
                                    expression: "`required|make_choice`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersContractType,
                                  name: _vm.usersContractTypeInput,
                                  options: _vm.usersContractTypeOptions
                                },
                                on: { input: _vm.triggerContractDuration }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showDuration && _vm.income_form_work
                        ? [
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-textfield-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|numeric",
                                      expression: "`required|numeric`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersContractDuration,
                                    name: _vm.usersContractDurationInput
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-datepicker-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "`required`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersContractEndDate,
                                    name: _vm.usersContractEndDateInput
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersOccupation,
                              name: _vm.usersOccupationInput
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "`required|numeric`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersMonthlyIncome,
                              name: _vm.usersMonthlyIncomeInput
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "form__bottom-row" }, [
                            _vm._v(_vm._s(_vm.usersMonthlyIncomeNote))
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-radios-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "make_choice",
                                expression: "`make_choice`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersDoYouHaveGuarantorGeneral,
                              name: _vm.usersDoYouHaveGuarantorInput,
                              options: _vm.usersDoYouHaveGuarantorOptions
                            },
                            on: { input: _vm.triggerGuarantorForm }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.guarantor_form_state == 1
                        ? _c(
                            "li",
                            { staticClass: "form__item" },
                            [
                              _c("v-textfield-public", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "numeric",
                                    expression: "`numeric`"
                                  }
                                ],
                                attrs: {
                                  label: _vm.usersGuarantorIncome,
                                  name: _vm.usersGuarantorIncomeInput
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.income_form_studying
                  ? [
                      !_vm.income_form_work_business
                        ? [
                            _c(
                              "li",
                              { staticClass: "form__item" },
                              [
                                _c("v-radios-public", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|make_choice",
                                      expression: "`required|make_choice`"
                                    }
                                  ],
                                  attrs: {
                                    label: _vm.usersDoYouHaveGuarantor,
                                    name: _vm.usersDoYouHaveGuarantorInput,
                                    options: _vm.usersDoYouHaveGuarantorOptions
                                  },
                                  on: { input: _vm.triggerGuarantorForm }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.guarantor_form_state == 0 ||
                            _vm.guarantor_form_state == 2
                              ? _c(
                                  "li",
                                  { staticClass: "form__item" },
                                  [
                                    _c("v-radios-public", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|make_choice",
                                          expression: "`required|make_choice`"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.usersDoYouHaveOtherGuaranteeOptions,
                                        name:
                                          _vm.usersDoYouHaveOtherGuaranteeOptionsInput,
                                        options:
                                          _vm.usersDoYouHaveOtherGuaranteeOptionsOptions
                                      },
                                      model: {
                                        value:
                                          _vm.users_do_you_have_other_guarantee_options_value,
                                        callback: function($$v) {
                                          _vm.users_do_you_have_other_guarantee_options_value = $$v
                                        },
                                        expression:
                                          "users_do_you_have_other_guarantee_options_value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.users_do_you_have_other_guarantee_options_value ==
                              0 &&
                            (_vm.guarantor_form_state == 0 ||
                              _vm.guarantor_form_state == 2)
                              ? _c("li", { staticClass: "form__item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form__field-box" },
                                    [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "red" } },
                                        [_vm._v(_vm._s(_vm.declineFormMessage))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "`required`"
                                      }
                                    ],
                                    attrs: {
                                      type: "hidden",
                                      name: "cant_rent_a_house"
                                    }
                                  })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.guarantor_form_state == 1
                              ? _c(
                                  "li",
                                  { staticClass: "form__item" },
                                  [
                                    _c("v-textfield-public", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "`required|numeric`"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.usersGuarantorIncome,
                                        name: _vm.usersGuarantorIncomeInput
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "form__item" },
                        [
                          _c("v-textfield-public", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "`required`"
                              }
                            ],
                            attrs: {
                              label: _vm.usersStudy,
                              name: _vm.usersStudyInput
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.income_form_any
                  ? _c(
                      "li",
                      { staticClass: "form__item form__item--align-start" },
                      [
                        _c("label", { staticClass: "form__label" }, [
                          _vm._v(_vm._s(_vm.usersExtraInformationIncome))
                        ]),
                        _vm._v(" "),
                        _c(
                          "textarea",
                          {
                            staticClass: "form__textarea",
                            attrs: {
                              name: _vm.usersExtraInformationIncomeInput
                            }
                          },
                          [_vm._v(_vm._s(_vm.usersIncomeNote))]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website != "staffhousing"
        ? _c("div", { staticClass: "form__heading" }, [
            _c("h2", { staticClass: "form__title" }, [
              _vm._v(_vm._s(_vm.usersLandlordDetails))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website != "staffhousing"
        ? _c("ul", { staticClass: "form__list" }, [
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-radios-public", {
                  attrs: {
                    label: _vm.usersLandlordLabel,
                    name: _vm.usersLandlordRadio,
                    options: _vm.usersLandlordOptions
                  },
                  on: { input: _vm.triggerLandlordType }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.landlord_type_state == "renting_property"
              ? _c("li", { staticClass: "form__item" }, [
                  _c("ul", { staticClass: "form__list" }, [
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          attrs: {
                            label: _vm.usersLandlordName,
                            name: "person[0][landlord_name]"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "email",
                              expression: "`email`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersLandlordEmail,
                            name: "person[0][landlord_email]"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "form__item" },
                      [
                        _c("v-textfield-public", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "phone_number",
                              expression: "`phone_number`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersLandlordPhone,
                            name: "person[0][landlord_phone_number]"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website != "staffhousing"
        ? _c("div", { staticClass: "form__heading" }, [
            _c("h2", { staticClass: "form__title" }, [
              _vm._v(_vm._s(_vm.subscriptionsYourDetails))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.website != "staffhousing"
        ? _c("ul", { staticClass: "form__list" }, [
            _c(
              "li",
              { staticClass: "form__item form__item--no-label" },
              [
                _c("v-radios-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|make_choice",
                      expression: "`required|make_choice`"
                    }
                  ],
                  attrs: {
                    "validation-label":
                      (_vm.locales &&
                        _vm.locales.users &&
                        _vm.locales.users.title) + " (*)",
                    name: _vm.subscriptionsSexInput,
                    options: _vm.subscriptionsSexOptions
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-radios-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "`required`"
                    }
                  ],
                  attrs: {
                    label:
                      _vm.locales &&
                      _vm.locales.users &&
                      _vm.locales.users.language,
                    value: _vm.defaultLanguage,
                    name: "person[0][language]",
                    "show-zero-option": "0",
                    options: _vm.languages
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.subscriptionsFirstName,
                    name: _vm.subscriptionsFirstNameInput
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  attrs: {
                    label: _vm.subscriptionsMiddleName,
                    name: _vm.subscriptionsMiddleNameInput
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|alpha_spaces_dash",
                      expression: "`required|alpha_spaces_dash`"
                    }
                  ],
                  attrs: {
                    label: _vm.subscriptionsLastName,
                    name: _vm.subscriptionsLastNameInput
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  ref: "person_postcode_0",
                  staticClass: "js-postcode",
                  attrs: {
                    name: _vm.subscriptionsPostCode,
                    label:
                      _vm.locales &&
                      _vm.locales.users &&
                      _vm.locales.users.post_code
                  },
                  on: {
                    blur: function($event) {
                      return _vm.checkPcHn($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  ref: "person_housenumber_0",
                  staticClass: "js-house-number",
                  attrs: {
                    name: _vm.subscriptionsHouseNumber,
                    label:
                      _vm.locales &&
                      _vm.locales.users &&
                      _vm.locales.users.house_number
                  },
                  on: {
                    blur: function($event) {
                      return _vm.checkPostcodeAddress($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  ref: "person_street_0",
                  attrs: {
                    name: _vm.subscriptionsStreet,
                    label:
                      _vm.locales &&
                      _vm.locales.users &&
                      _vm.locales.users.street
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  ref: "person_city_0",
                  attrs: {
                    "is-update-model": true,
                    name: _vm.subscriptionsCity,
                    label:
                      _vm.locales && _vm.locales.users && _vm.locales.users.city
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.website == "athome"
              ? _c(
                  "li",
                  { staticClass: "form__item" },
                  [
                    _c("v-datepicker-public", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "`required`"
                        }
                      ],
                      attrs: {
                        label: _vm.subscriptionsDateOfBirth,
                        name: _vm.subscriptionsDateOfBirthInput
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|tel",
                      expression: "`required|tel`"
                    }
                  ],
                  staticClass: "js-unique-phone",
                  attrs: {
                    type: "tel",
                    label: _vm.subscriptionsPhoneNumber,
                    name: _vm.subscriptionsPhoneNumberInput
                  },
                  on: { blur: _vm.checkPhone }
                })
              ],
              1
            ),
            _vm._v(" "),
            !!_vm.is_phone_number_unique
              ? _c("li", { staticClass: "form__item" }, [
                  _c("label", { staticClass: "form__label" }),
                  _vm._v(" "),
                  _c("b", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.phoneNumberAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "phone_number_unique" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "`required|email`"
                    }
                  ],
                  staticClass: "js-unique-mail",
                  attrs: {
                    label: _vm.subscriptionsEmail,
                    name: _vm.subscriptionsEmailInput,
                    type: "email",
                    "is-prefill-disabled": true
                  },
                  on: { blur: _vm.checkMail }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.is_user_already_exists == 1
              ? _c("li", { staticClass: "form__item" }, [
                  _c("label", { staticClass: "form__label" }),
                  _vm._v(" "),
                  _c("b", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.isUserAlreadyExists))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm.is_user_already_exists == 2
              ? _c("li", { staticClass: "form__item" }, [
                  _c("label", { staticClass: "form__label" }),
                  _vm._v(" "),
                  _c("b", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.isUserBanned))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: { type: "hidden", name: "user_already_exists" }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "`required`"
                    }
                  ],
                  ref: "password0",
                  attrs: {
                    label: _vm.subscriptionsPassword,
                    name: _vm.subscriptionsPasswordInput,
                    type: "password",
                    "is-prefill-disabled": true
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "form__item" },
              [
                _c("v-textfield-public", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|confirmed:password0",
                      expression: "`required|confirmed:password0`"
                    }
                  ],
                  attrs: {
                    label: _vm.subscriptionsPasswordRepeat,
                    name: _vm.subscriptionsPasswordRepeatInput,
                    type: "password",
                    "is-prefill-disabled": true
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.number_of_adults_value_computed - 1, function(adult) {
        return _vm.number_of_adults_value > 1
          ? _c(
              "div",
              { key: adult },
              [
                _c("v-subscribe-inner-form", {
                  attrs: {
                    i: adult,
                    partner: _vm.partner,
                    "family-type-state": _vm.family_type_state,
                    subscriptions: _vm.innerFormSubscriptions,
                    "users-title-options": _vm.innerFormUsersTitleOptions,
                    "users-first-name": _vm.subscriptionsFirstName,
                    "users-middle-name": _vm.subscriptionsMiddleName,
                    "users-last-name": _vm.subscriptionsLastName,
                    "users-date-of-birth": _vm.subscriptionsDateOfBirth,
                    "users-phone-number": _vm.subscriptionsPhoneNumber,
                    "users-email": _vm.subscriptionsEmail,
                    "users-i-am": _vm.subscriptionsIAm,
                    "users-type-of-income-options":
                      _vm.subscriptionsTypeOfIncomeOptions,
                    "users-occupation": _vm.usersOccupation,
                    "users-contract-type": _vm.usersContractType,
                    "users-contract-type-options": _vm.usersContractTypeOptions,
                    "users-contract-type-attributes":
                      _vm.usersContractTypeAttributes,
                    "users-contract-duration": _vm.usersContractDuration,
                    "users-contract-end-date": _vm.usersContractEndDate,
                    "users-monthly-income": _vm.usersMonthlyIncome,
                    "users-monthly-income-note": _vm.usersMonthlyIncomeNote,
                    "users-do-you-have-guarantor": _vm.usersDoYouHaveGuarantor,
                    "users-do-you-have-guarantor-options":
                      _vm.usersDoYouHaveGuarantorOptions,
                    "users-guarantor-income": _vm.usersGuarantorIncome,
                    "users-study": _vm.usersStudy,
                    "users-extra-information-income":
                      _vm.usersExtraInformationIncome,
                    "users-type-of-income-slugs":
                      _vm.subscriptionsTypeOfIncomeSlugs,
                    "income-form-all-states": _vm.incomeFormAllStates,
                    "income-title": _vm.subscriptionsIncome,
                    "income-is-user-already-exists": _vm.isUserAlreadyExists,
                    "income-is-user-banned": _vm.isUserBanned,
                    "income-phone-number-already-exists":
                      _vm.phoneNumberAlreadyExists,
                    "users-landlord-options": _vm.usersLandlordOptions,
                    languages: _vm.languages,
                    "default-language": _vm.defaultLanguage
                  }
                })
              ],
              1
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _c("v-search-profile-form", {
        attrs: {
          website: _vm.website,
          "search-profile-title": _vm.searchProfileTitle,
          "sp-city-title": _vm.spCityTitle,
          "sp-district-title": _vm.spDistrictTitle,
          "sp-distance-title": _vm.spDistanceTitle,
          "sp-distance-options": _vm.spDistanceOptions,
          "sp-distance-value": _vm.spDistanceValue,
          "sp-rental-price-from-title": _vm.spRentalPriceFromTitle,
          "sp-rental-price-from-options": _vm.spRentalPriceFromOptions,
          "sp-rental-price-from-value": _vm.spRentalPriceFromValue,
          "sp-rental-price-to-title": _vm.spRentalPriceToTitle,
          "sp-rental-price-to-options": _vm.spRentalPriceToOptions,
          "sp-rental-price-to-value": _vm.spRentalPriceToValue,
          "sp-bedrooms-title": _vm.spBedroomsTitle,
          "sp-bedrooms-options": _vm.spBedroomsOptions,
          "sp-bedrooms-value": _vm.spBedroomsValue,
          "sp-surface-title": _vm.spSurfaceTitle,
          "sp-surface-options": _vm.spSurfaceOptions,
          "sp-surface-value": _vm.spSurfaceValue,
          "sp-property-type-title": _vm.spPropertyTypeTitle,
          "sp-property-type-options": _vm.spPropertyTypeOptions,
          "sp-property-type-value": _vm.spPropertyTypeValue,
          "sp-interior-title": _vm.spInteriorTitle,
          "sp-interior-options": _vm.spInteriorOptions,
          "sp-interior-value": _vm.spInteriorValue,
          "sp-suitable-for-sharing-title": _vm.spSuitableForSharingTitle,
          "sp-suitable-for-sharing-options": _vm.spSuitableForSharingOptions,
          "sp-suitable-for-sharing-value": _vm.spSuitableForSharingValue,
          "sp-parking-space-title": _vm.spParkingSpaceTitle,
          "sp-parking-space-options": _vm.spParkingSpaceOptions,
          "sp-parking-space-value": _vm.spParkingSpaceValue,
          "sp-rent-period-title": _vm.spRentPeriodTitle,
          "sp-rent-period-options": _vm.spRentPeriodOptions,
          "sp-rent-period-value": _vm.spRentPeriodValue,
          "sp-start-date-rent-title": _vm.spStartDateRentTitle,
          "sp-start-date-rent-value": _vm.spStartDateRentValue,
          "sp-extra-information-title": _vm.spExtraInformationTitle,
          "sp-no-preference": _vm.spNoPreference,
          "sp-add": _vm.spAdd,
          "sp-reduce": _vm.spReduce,
          "sp-rental-text-title": _vm.spRentalTextTitle,
          "sp-week-price-title": _vm.spWeekPriceTitle,
          "sp-number-of-men-title": _vm.spNumberOfMenTitle,
          "sp-number-of-women-title": _vm.spNumberOfWomenTitle,
          "sp-min-number-of-bedrooms-title": _vm.spMinNumberOfBedroomsTitle,
          "sp-parking-places-title": _vm.spParkingPlacesTitle,
          "sp-parking-places-options": _vm.spParkingPlacesOptions
        }
      }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "form__list" },
        [
          _vm.website != "staffhousing"
            ? _c(
                "li",
                { staticClass: "form__item" },
                [
                  _c("v-checkboxes-public", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    staticClass: "form__radio",
                    attrs: {
                      "label-html": _vm.subscribeToNewsletter,
                      options: { "1": "" },
                      name: ""
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.website != "staffhousing"
            ? [
                _c("li", { staticClass: "form__item" }, [
                  _vm._v("\n        " + _vm._s(_vm.requestSrcInfo) + "\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    staticClass:
                      "form__item form__item--center form__item--request-src"
                  },
                  [
                    _c("v-checkboxes-public", {
                      staticClass: "form__radio",
                      attrs: {
                        "label-html": _vm.requestSrc,
                        options: { "1": "" },
                        disabled: "disabled",
                        name: "request_src",
                        id: "requestSrcCheckbox"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "i",
                      {
                        staticClass: "func-request-src-item form-checkbox-info"
                      },
                      [_vm._v("(" + _vm._s(_vm.checkBoxInfo) + ")")]
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("li", { staticClass: "form__item" }, [
            _c(
              "button",
              {
                staticClass: "form__button",
                attrs: { id: "submitFormBtn", type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.submitForm.apply(null, arguments)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.commonSend) + "\n      ")]
            )
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec8a657a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec8a657a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin/components/VSubscribeForm.vue
// module id = 440
// module chunks = 1